import React from 'react';
import AdminPFNominationPreview from './AdminPFNominationPreview';
import AdminFamilyDetailsPreview from './AdminFamilyDetailsPreview';
import AdminMarriageDeclarationPreview from './AdminMarriageDeclarationPreview';
import AdminRelationshipDeclarationPreview from './AdminRelationshipDeclarationPreview';

/**
 * EmployeeSubmissionPreview - Admin preview component for Employee360
 * 
 * Renders employee submitted joining forms in read-only mode inside Employee360 modal.
 * Receives complete submission object via props (no routing/API calls).
 * 
 * @param {Object} submission - The submission object from employee_form_submissions
 * @param {string} submission.form_code - Form code (PF_NOM, FAMILY, MARR_DECL, REL_DECL)
 * @param {Object} submission.form_data - Form data JSON
 * @param {boolean} readOnly - Always true for admin preview
 */
export default function EmployeeSubmissionPreview({ submission, readOnly = true }) {
  if (!submission) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">No submission data available</div>
      </div>
    );
  }

  if (!submission.form_data) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">No form data available</div>
      </div>
    );
  }

  // Switch on form_code to render appropriate preview component
  switch (submission.form_code) {
    case 'PF_NOM':
      return <AdminPFNominationPreview submission={submission} readOnly={readOnly} />;
    case 'FAMILY':
      return <AdminFamilyDetailsPreview submission={submission} readOnly={readOnly} />;
    case 'MARR_DECL':
      return <AdminMarriageDeclarationPreview submission={submission} readOnly={readOnly} />;
    case 'REL_DECL':
      return <AdminRelationshipDeclarationPreview submission={submission} readOnly={readOnly} />;
    default:
      return (
        <div className="flex items-center justify-center py-12">
          <div className="text-gray-500">
            Unknown form code: {submission.form_code}
          </div>
        </div>
      );
  }
}
